import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M835.9424,632.5632 L244.9664,632.5632 L723.0464,154.4832 L632.5504,63.9872 L-0.0256,696.5632 L632.5504,1329.1392 L723.0464,1238.6432 L244.9664,760.5632 L835.9424,760.5632 C1340.3904,760.5632 1750.7584,1170.9312 1750.7584,1675.3792 L1750.7584,1784.5632 L1878.7584,1784.5632 L1878.7584,1675.3792 C1878.7584,1100.4032 1410.9184,632.5632 835.9424,632.5632",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconReplyLine = /*#__PURE__*/function (_Component) {
  _inherits(IconReplyLine, _Component);

  var _super = _createSuper(IconReplyLine);

  function IconReplyLine() {
    _classCallCheck(this, IconReplyLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconReplyLine, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconReply",
        viewBox: "0 0 1920 1920",
        bidirectional: true
      }), _ref);
    }
  }]);

  IconReplyLine.displayName = "IconReplyLine";
  return IconReplyLine;
}(Component);

IconReplyLine.glyphName = 'reply';
IconReplyLine.variant = 'Line';
IconReplyLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconReplyLine;
export { IconReplyLine };